<script setup lang="ts">
import { NXGDSSpinner } from '@nsftx/seven-nxg-design-system'

withDefaults(
  defineProps<{
    visible: boolean
    label?: string
  }>(),
  {
    label: 'Loading'
  }
)
</script>

<template>
  <div v-if="visible" class="nxg-retail-loading-overlay" data-cy="spinner" role="status" :aria-label="label">
    <NXGDSSpinner
      background-color="conic-gradient(from 90deg, rgba(255, 255, 255, 1) 0deg, rgba(255, 255, 255, 0) 0.036deg, rgba(255, 255, 255, 1) 360deg)"
      width="40px" height="40px" />
  </div>
</template>

<style scoped>
.nxg-retail-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: var(--nxgds-alias-z-index-overlay, 1000);
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(0 0 0 / 80%);
}
</style>
